export const NotFound = () => <div>Not found</div>;
